import React from 'react';
import './Projects.css';

function ProjectCard({
  projectName,
  started,
  projectDescription,
  imageUrl,
  projectUrl,
}) {
  return (
    <div className="project-card glass-card">
      <div className="project-img-wrapper">
        <img
          src={imageUrl}
          alt={`${projectName} showcase`}
          className="project-image"
          loading="lazy"
        />
        <div className="project-img-overlay">
          {projectUrl && projectUrl !== '#' && (
            <a 
              href={projectUrl} 
              className="project-overlay-link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Visit Website 🌐
            </a>
          )}
        </div>
      </div>

      <div className="project-details-container">
        <div className="project-card-header">
          <h3 className="project-heading">{projectName}</h3>
          {started && <span className="project-duration">{started}</span>}
        </div>
        
        <p className="project-details">{projectDescription}</p>

        {projectUrl && projectUrl !== '#' ? (
          <div className="project-action-wrapper">
            <a 
              href={projectUrl} 
              className="project-text-link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Live Demo <span className="arrow">&rarr;</span>
            </a>
          </div>
        ) : (
          <div className="project-action-wrapper">
            <span className="project-text-link disabled">
              Case Study / Internal App
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectCard;
